import * as Yup from 'yup';

const email = Yup.string()
  .trim()
  .required('Email address is required')
  .email('Email must be valid');

export default email;
